// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import RequestFormModel from '../../model/request-form-model';
import RequestFormDTO from '../dto/request-form-dto';
import dtoSchema from '../schemas/request-form-schema';
import ResourceLinkModel from '../../model/resource-link-model';

export default abstract class RequestFormModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<RequestFormDTO>) {
    super();
    if (data) {
      this.id = data.id;
      this.links = data.links?.map((i) => ResourceLinkModel.toModel(i)) ?? [];
      this.creatorId = data.creatorId;
      this.creatorName = data.creatorName ?? undefined;
      this.created = data.created;
      this.modifierId = data.modifierId ?? undefined;
      this.modifierName = data.modifierName ?? undefined;
      this.modified = data.modified ?? undefined;
      this.submissionDate = data.submissionDate;
      this.requestId = data.requestId ?? undefined;
      this.formType = data.formType ?? undefined;
      this.formSubType = data.formSubType ?? undefined;
      this.formSummaryType = data.formSummaryType ?? undefined;
      this.customerEmail = data.customerEmail ?? undefined;
      this.isCompleted = data.isCompleted ?? undefined;
      this.paymentType = data.paymentType ?? undefined;
      this.paymentTransactionId = data.paymentTransactionId ?? undefined;
      this.paymentState = data.paymentState ?? undefined;
      this.reminderState = data.reminderState ?? undefined;
      this.integrationCallId = data.integrationCallId ?? undefined;
      this.requestObject = data.requestObject ?? undefined;
      this.reminderSentOn = data.reminderSentOn ?? undefined;
      this.paymentObject = data.paymentObject ?? undefined;
      this.reminderIntegrationCallId = data.reminderIntegrationCallId ?? undefined;
      this.language = data.language ?? undefined;
      this.comment = data.comment ?? undefined;
    }
  }
  /**
  * @type {int64}
  */
  id?: number;
  /**
  */
  links?: ResourceLinkModel[];
  /**
  * @type {int64}
  */
  creatorId?: number;
  /**
  */
  creatorName?: string;
  /**
  * @type {date-time}
  */
  created?: string;
  /**
  * @type {int64}
  */
  modifierId?: number;
  /**
  */
  modifierName?: string;
  /**
  * @type {date-time}
  */
  modified?: string;
  /**
  * @type {date-time}
  */
  submissionDate?: string;
  /**
  */
  requestId?: string;
  /**
  */
  formType?: string;
  /**
  */
  formSubType?: string;
  /**
  */
  formSummaryType?: string;
  /**
  */
  customerEmail?: string;
  /**
  */
  isCompleted?: boolean;
  /**
  */
  paymentType?: string;
  /**
  */
  paymentTransactionId?: string;
  /**
  */
  paymentState?: string;
  /**
  */
  reminderState?: string;
  /**
  * @type {int32}
  */
  integrationCallId?: number;
  /**
  */
  requestObject?: string;
  /**
  * @type {date-time}
  */
  reminderSentOn?: string;
  /**
  */
  paymentObject?: string;
  /**
  * @type {int32}
  */
  reminderIntegrationCallId?: number;
  /**
  */
  language?: string;
  /**
  */
  comment?: string;

  static toModel(dto: DeepPartial<RequestFormDTO>): RequestFormModel;
  static toModel(dto: DeepPartial<RequestFormDTO> | undefined | null): RequestFormModel | undefined;
  static toModel(dto: DeepPartial<RequestFormDTO> | undefined | null): RequestFormModel | undefined {
    return dto ? new RequestFormModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<RequestFormModel> | RequestFormModel): RequestFormDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      id: unwrapped.id,
      links: unwrapped.links,
      creatorId: unwrapped.creatorId,
      creatorName: unwrapped.creatorName,
      created: unwrapped.created,
      modifierId: unwrapped.modifierId,
      modifierName: unwrapped.modifierName,
      modified: unwrapped.modified,
      submissionDate: unwrapped.submissionDate,
      requestId: unwrapped.requestId,
      formType: unwrapped.formType,
      formSubType: unwrapped.formSubType,
      formSummaryType: unwrapped.formSummaryType,
      customerEmail: unwrapped.customerEmail,
      isCompleted: unwrapped.isCompleted,
      paymentType: unwrapped.paymentType,
      paymentTransactionId: unwrapped.paymentTransactionId,
      paymentState: unwrapped.paymentState,
      reminderState: unwrapped.reminderState,
      integrationCallId: unwrapped.integrationCallId,
      requestObject: unwrapped.requestObject,
      reminderSentOn: unwrapped.reminderSentOn,
      paymentObject: unwrapped.paymentObject,
      reminderIntegrationCallId: unwrapped.reminderIntegrationCallId,
      language: unwrapped.language,
      comment: unwrapped.comment,
    } as RequestFormDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for RequestFormModel, can not map to RequestFormDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
